import { login } from '@onclicks/sharedmedusa/medusaData/customer'
import { Input } from '../ui/input'
import ErrorMessage from '../checkout/ErrorMessage'
import { useActionState, useState } from 'react'
import Link from 'next/link'
import { Button } from '../ui/Button'
import { cn } from '@/utilities/ui'
import { bagelFatOne } from '@/utilities/fontImport'

const Login = () => {
  const [message, formAction, isPending] = useActionState(login, null)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  return (
    <div className="flex h-full flex-col overflow-hidden rounded-[2.5rem] border border-white bg-white shadow-xl shadow-light-pink/40">
      <div className="h-1.5 bg-linear-to-r from-secondary to-pink" />

      <div className="flex flex-col p-8 lg:p-10" data-testid="login-page">
        <span className="text-xs font-extrabold tracking-wide text-secondary uppercase">
          Bienvenue
        </span>
        <h1 className={cn('text-2xl font-bold mt-2 mb-6 text-primary', bagelFatOne.className)}>
          Se connecter
        </h1>

        <form className="w-full" action={formAction}>
          <div className="flex flex-col w-full gap-4">
            <Input
              label="Adresse e-mail"
              id="email"
              type="email"
              name="email"
              placeholder="Votre email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <Input
              label="Mot de passe"
              id="password"
              type="password"
              name="password"
              placeholder="Votre mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <ErrorMessage error={message} />

          <div className="mt-2 text-right">
            <Link className="text-sm font-bold text-secondary hover:underline" href="/account/request-reset-password">
              Mot de passe oublié ?
            </Link>
          </div>

          <Button
            type="submit"
            disabled={isPending}
            data-testid="sign-in-button"
            className="mt-6 w-full"
            variant="gradientOrangeToPink"
          >
            Se connecter
          </Button>
        </form>
      </div>
    </div>
  )
}

export default Login
